var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import axios from "axios";
export function getErrorMessage(exception, defaultMessage) {
    var _a, _b, _c, _d;
    if (defaultMessage === void 0) { defaultMessage = "Unexpected error"; }
    if (axios.isAxiosError(exception)) {
        return (_d = (_c = (_b = (_a = exception.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.description) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : defaultMessage;
    }
    return defaultMessage;
}
export var parseHeader = function (headerValue) {
    if (headerValue === "") {
        return {};
    }
    var pairs = headerValue.split(";");
    var splittedPairs = pairs.map(function (pair) { return pair.split("="); });
    return splittedPairs.reduce(function (acc, nextValue) {
        var _a;
        var key = decodeURIComponent(nextValue[0].trim());
        if (!key) {
            return acc;
        }
        var value = typeof nextValue[1] !== "undefined" ? decodeURIComponent(nextValue[1].trim()) : undefined;
        return __assign(__assign({}, acc), (_a = {}, _a[key] = value, _a));
    }, {});
};
